module.exports = __webpack_public_path__ + "static/ndclondon19-3251a1308f30f9fee0c2d777931d8cd5.jpeg";